import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sre_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imageUrl = (img) => {
  if (!img) return "";
  if (img.startsWith("http") || img.startsWith("/")) return img;
  return `${API}/files/${img}`;
};

export default api;
